module.exports = __webpack_public_path__ + "static/media/BimViewer.45867b09.svg";